// Frontend-only mirror of api/src/access-control/dto/get-access-logs.dto.ts.
// Not synced via dto:sync — the backend DTO imports @nestjs/swagger decorators
// and an entity-file enum, both of which dto-syncer.js treats as backend-only.

import { AccessControlProviderType } from './access-control-config.dto';

export enum AccessLogEventType {
  ENTRY = 'entry',
  EXIT = 'exit',
  DENIED = 'denied',
  FORCED = 'forced',
}

export type GetAccessLogsInputDto = {
  doorId?: string;
  // Rollout item 9 (Enzo Card passage-event ingestion) — the fiche-client
  // filter. Pass a player's userId to scope the log view to them.
  userId?: string;
  eventType?: AccessLogEventType;
  // Hardening status doc item C91 — lets an org running two vendors
  // concurrently (C53/C58) narrow the log view down to one. Type parity
  // only; no filter UI wired up yet (out of this backend routine's scope).
  provider?: AccessControlProviderType;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
};

export type AccessLogDto = {
  id: string;
  credentialId?: string;
  doorId: string;
  eventType: AccessLogEventType;
  occurredAt: string;
  createdAt: string;
  // Null for rows persisted before this field existed (C86/C91).
  provider?: AccessControlProviderType;
  // Rollout item 9 — null for every booking-linked row (those resolve their
  // player via credentialId instead; see AccessLog.user's doc comment on the
  // backend entity). Set for ambient zone passages (HYROX, plateau
  // cardio/musculation) that have no booking behind them.
  userId?: string;
  userName?: string;
};

export type AccessLogsPaginationDto = {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
};

export type GetAccessLogsOutputDto = {
  logs: AccessLogDto[];
  pagination: AccessLogsPaginationDto;
};
